import React, { useMemo } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import DataTable from "react-data-table-component";
import moment from "moment";
import { longDateString } from "../../utils";
import "../../starek.css";

function MaintenanceSchedulesListingView({
    items,
    selectedRows,
    onSelectedRowsChange,
    filterText,
    toggleCleared,
}) {
    const flattenedSchedules = useMemo(() => {
        const schedules = [];
        items.forEach((device) => {
            (device.maintenance_schedules || []).forEach((schedule) => {
                let attrs = schedule?.schedule_attributes;
                if (typeof attrs === "string") {
                    try {
                        attrs = JSON.parse(attrs);
                    } catch {
                        attrs = { when: attrs };
                    }
                }

                schedules.push({
                    id: `${device.id}-${schedule.id}`,
                    deviceId: device.id,
                    deviceName: device.name || device.id,
                    scheduleId: schedule.id,
                    scheduleType: schedule.schedule_type || "-",
                    from: attrs?.from || "-",
                    to: attrs?.to || "-",
                    when: attrs?.when || "-",
                    device: device,
                    schedule: schedule,
                });
            });
        });
        return schedules;
    }, [items]);

    const filteredItems = useMemo(() => {
        const q = filterText?.trim().toLowerCase();
        if (!q) return flattenedSchedules;
        return flattenedSchedules.filter(
            (item) =>
                String(item.deviceName || "")
                    .toLowerCase()
                    .includes(q) ||
                String(item.scheduleType || "")
                    .toLowerCase()
                    .includes(q) ||
                String(item.when || "")
                    .toLowerCase()
                    .includes(q)
        );
    }, [flattenedSchedules, filterText]);

    const columns = [
        {
            name: "Device",
            selector: (r) => r.deviceName || "",
            sortable: true,
            height: "50px",
            grow: 1.5,
        },
        {
            name: "Type",
            selector: (r) => String(r.scheduleType || ""),
            sortable: true,
            height: "50px",
            width: "150px",
        },
        {
            name: "From",
            selector: (r) => r.from || "",
            sortable: true,
            height: "50px",
            width: "180px",
            cell: (r) => {
                if (!r.from || r.from === "-") return "-";
                try {
                    return moment(r.from).format("lll");
                } catch {
                    return r.from;
                }
            },
        },
        {
            name: "To",
            selector: (r) => r.to || "",
            sortable: true,
            height: "50px",
            width: "180px",
            cell: (r) => {
                if (!r.to || r.to === "-") return "-";
                try {
                    return moment(r.to).format("lll");
                } catch {
                    return r.to;
                }
            },
        },
        {
            name: "When",
            selector: (r) => r.when || "",
            sortable: true,
            height: "50px",
            grow: 3,
            cell: (r) => (
                <div className="text-truncate h-50px" style={{ maxWidth: 250 }}>
                    {r.when || "-"}
                </div>
            ),
        },
        {
            name: "Activity",
            selector: (r) => r.schedule?.updated_at,
            sortable: true,
            height: "50px",
            width: "250px",
            cell: (r) => (
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip>
                            <div>
                                Created by{" "}
                                {r.schedule?.created_by?.name || "Unknown"} at{" "}
                                {r.schedule?.created_at
                                    ? longDateString(r.schedule.created_at)
                                    : "-"}
                            </div>
                            <div>
                                Modified by{" "}
                                {r.schedule?.updated_by?.name || "Unknown"} at{" "}
                                {r.schedule?.updated_at
                                    ? longDateString(r.schedule.updated_at)
                                    : "-"}
                            </div>
                        </Tooltip>
                    }
                >
                    <div style={{ fontSize: "0.85rem" }}>
                        {r.schedule?.updated_by?.name || "Unknown"} at{" "}
                        {r.schedule?.updated_at
                            ? longDateString(r.schedule.updated_at)
                            : "-"}
                    </div>
                </OverlayTrigger>
            ),
        },
    ];

    return (
        <DataTable
            columns={columns}
            data={filteredItems}
            selectableRows
            onSelectedRowsChange={onSelectedRowsChange}
            clearSelectedRows={toggleCleared}
            highlightOnHover
            striped
            pointerOnHover
            responsive
            pagination
            dense
            selectableRowsHighlight
            selectableRowsNoSelectAll={false}
        />
    );
}

export default MaintenanceSchedulesListingView;
